export default {"src":"/_next/static/image/public/images/flags/flag_675.f51f35bc5b47bb5b58c963386082e229.svg","height":16,"width":24};